function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAAA IDP Payment next steps component
 * 
 */
import * as React from 'react';
import './NextSteps.scss';
import { clubDomain, CLUB_CONTACTS } from '../../../data/Data';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class NextSteps extends React.Component {
  render() {
    const {
      content,
      postageDescription
    } = this.props;
    const {
      hostname
    } = window.location;
    const club = clubDomain(hostname);
    const contacts = CLUB_CONTACTS[club];
    return /*#__PURE__*/_jsxs("div", {
      className: "NextSteps",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "steps",
        children: [/*#__PURE__*/_jsx("div", {
          className: "path path1"
        }), /*#__PURE__*/_jsx("div", {
          className: "path path2"
        }), content.map((item, index) => {
          return /*#__PURE__*/_jsxs("div", {
            className: "box",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "head",
              children: [/*#__PURE__*/_jsx("div", {
                className: "index",
                children: index + 1
              }), postageDescription && postageDescription === 'In-store pickup' && item.titlePickup ? /*#__PURE__*/_jsx("h4", {
                className: "title",
                children: item.titlePickup
              }) : /*#__PURE__*/_jsx("h4", {
                className: "title",
                children: item.title
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "content",
              children: [/*#__PURE__*/_jsx("div", {
                className: "vpath-container",
                children: /*#__PURE__*/_jsx("div", {
                  className: "vpath"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "copy",
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              }), postageDescription && postageDescription === 'In-store pickup' ? /*#__PURE__*/_jsx("div", {
                className: "copy",
                dangerouslySetInnerHTML: {
                  __html: item.contentPickup
                }
              }) : /*#__PURE__*/_jsx("div", {
                className: "copy",
                dangerouslySetInnerHTML: {
                  __html: item.contentPostage
                }
              })]
            })]
          }, index);
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "contact",
        children: ["For any questions about your order please contact ", club, ":", ' ', contacts.phone ? /*#__PURE__*/_jsxs("span", {
          children: ["phone ", /*#__PURE__*/_jsx("a", {
            href: 'tel:' + contacts.phone,
            children: contacts.phone
          })]
        }) : '', ' ', contacts.phone && contacts.email ? 'or' : '', ' ', contacts.email ? /*#__PURE__*/_jsxs("span", {
          children: ["email ", /*#__PURE__*/_jsx("a", {
            href: 'mailto:' + contacts.email,
            children: contacts.email
          })]
        }) : '', "."]
      })]
    });
  }
}
_defineProperty(NextSteps, "defaultProps", {
  content: []
});
export default NextSteps;